import { render } from "./CancelDelivery.vue?vue&type=template&id=2e0e677f&scoped=true"
import script from "./CancelDelivery.vue?vue&type=script&lang=js"
export * from "./CancelDelivery.vue?vue&type=script&lang=js"

import "./CancelDelivery.vue?vue&type=style&index=0&id=2e0e677f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0e677f"]])

export default __exports__